import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-data-filter-switch',
  templateUrl: './data-filter-switch.component.html',
  styleUrls: ['./data-filter-switch.component.scss']
})

export class DataFilterSwitchComponent implements OnInit {

  @Input()
  labelKey: string;

  @Input()
  model: boolean;

  @Output()
  modelChange = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnInit() {
  }

  change() {
    this.modelChange.emit(this.model);
  }
}
